package com.gsb.vyapar.bhagya.presentation.navigation.view

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Card
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.gsb.vyapar.bhagya.domain.getId
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.Screens
import com.gsb.vyapar.bhagya.presentation.category.event.CategoriesViewUiEvents
import com.gsb.vyapar.bhagya.presentation.category.view.CategoryGrid
import com.gsb.vyapar.bhagya.presentation.common.edittext.HomeSearchEditText
import com.gsb.vyapar.bhagya.presentation.common.edittext.SearchEditText
import com.gsb.vyapar.bhagya.presentation.common.image.CategoryPlaceHolder
import com.gsb.vyapar.bhagya.presentation.common.image.CommonImage
import com.gsb.vyapar.bhagya.presentation.common.text.Text14RegularB
import com.gsb.vyapar.bhagya.presentation.common.text.Text18SemiBoldC
import com.gsb.vyapar.bhagya.presentation.common.text.Text24SemiBold
import com.gsb.vyapar.bhagya.presentation.common.text.Text24SemiBoldI
import com.gsb.vyapar.bhagya.presentation.navigation.util.pushView
import com.gsb.vyapar.bhagya.presentation.search.uistate.getSearchUiState
import com.gsb.vyapar.bhagya.theme.black
import com.gsb.vyapar.bhagya.theme.offwhite
import com.gsb.vyapar.bhagya.theme.primary
import com.gsb.vyapar.bhagya.theme.splash
import com.gsb.vyapar.bhagya.theme.white

@Composable
fun HomeView(
    uiState: UiState,
    onTriggerEvent: (UiEvents) -> Unit,
    onMapInteractionChanged: (Boolean) -> Unit,
) {
    Surface(
        modifier = Modifier.fillMaxSize(),
        color = MaterialTheme.colors.background
    ) {
        val scrollState = rememberScrollState()
        var isMapInteracting by remember { mutableStateOf(false) }

        Column(
            Modifier
                .verticalScroll(scrollState, enabled = !isMapInteracting)
                .padding(all = 16.dp)
        ) {
            Card(
                modifier = Modifier.fillMaxWidth(),
                shape = RoundedCornerShape(8.dp),
                backgroundColor = offwhite,
            ) {
                Column(Modifier.padding(all = 16.dp), horizontalAlignment = Alignment.CenterHorizontally) {
                    Text24SemiBoldI(text = "Find & Discover GSB Konkani Businesses, Products, and Services", color = black, modifier = Modifier.fillMaxWidth())
                    HomeSearchEditText {
                        getSearchUiState().resetSearch()
                        pushView(Screens.Search)
                    }
                    CommonImage(splash, 150.dp, 150.dp)
                }
            }
            Spacer(Modifier.height(12.dp))
            Text24SemiBoldI(text = "Browse by Category", color = black)
            Spacer(Modifier.height(12.dp))
            LazyRow {
                items(uiState.getCategories().getCategoriesList(), key = { it.id }) { category ->
                    Card(
                        modifier = Modifier.width(170.dp).height(170.dp).padding(4.dp),
                        shape = RoundedCornerShape(8.dp),
                        backgroundColor = offwhite,
                    ) {
                        Column(
                            horizontalAlignment = Alignment.CenterHorizontally,
                            verticalArrangement = Arrangement.Center,
                            modifier = Modifier.clickable {
                                onTriggerEvent(UiEvents.CategoryEvents(CategoriesViewUiEvents.ShowCategory(category)))
                            }
                        ) {
                            CategoryPlaceHolder(category.id.toInt(), 100.dp, 100.dp)
                            Text14RegularB(text = category.name, color = black)
                        }
                    }
                    Spacer(Modifier.height(8.dp))
                }
            }
            Spacer(Modifier.height(12.dp))
            HomeBusinessMap(
                uiState = uiState,
                onTriggerEvent = onTriggerEvent,
                onInteractionChanged = { interacting ->
                    if (isMapInteracting != interacting) {
                        isMapInteracting = interacting
                        onMapInteractionChanged(interacting)
                    }
                }
            )
            Spacer(Modifier.height(12.dp))
            AboutGSBVyaparBhagyaView(uiState, onTriggerEvent)
        }
    }
}